document.addEventListener('DOMContentLoaded', () => {
	let searchBars = document.querySelectorAll('.search-trigger');
	let resultsWrapper = document.querySelector('.predictive-search-container')
	let resultsContainer = resultsWrapper.querySelector('.inner');

	// console.log("SEARCH")

	searchBars.forEach(searchBar => {

		// Site search using predictive search api
		const predictiveSearchCallBack = () => {
			const section_name = 'hk-predictive-search';

			if (searchBar.value.length > 2) {

				var requestResponse;
				fetch(`/search/suggest?q=${searchBar.value}&resources[type]=product&section_id=${section_name}`)
					.then((response) => {
						requestResponse = response;
						return response.text();
					})
					.then((text) => {
						if (!requestResponse.ok) {
							throw new Error(`${requestResponse.status}: ${text}`);
						}
						resultsWrapper.classList.add('active');

						let resultsMarkup = new DOMParser()
							.parseFromString(text, 'text/html')
							.querySelector(`#shopify-section-${section_name}`).innerHTML;

						// Handle locale URLs - check if Shopify routes root has locale prefix
						if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root && window.Shopify.routes.root !== '/') {
							const localePrefix = window.Shopify.routes.root;
							// Replace product URLs to include locale prefix
							resultsMarkup = resultsMarkup.replace(/href="\/products\//g, `href="${localePrefix}products/`);
						}

						resultsContainer.innerHTML = resultsMarkup;
					})
					.catch((error) => {
						console.error(error);
					});
			} else {
				resultsContainer.innerHTML = '';
				resultsWrapper.classList.remove('active');
			}
		}

		let searchMethod = predictiveSearchCallBack;

		if (searchBar && resultsContainer) {
			searchBar.addEventListener('keyup', searchMethod)
		}
	})

})